import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ClassNote = function ClassNote(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 11C19.447 11 19 11.448 19 12V18C19 18.551 18.552 19 18 19H6C5.448 19 5 18.551 5 18V6C5 5.449 5.448 5 6 5H12C12.553 5 13 4.552 13 4C13 3.448 12.553 3 12 3H6C4.346 3 3 4.346 3 6V18C3 19.654 4.346 21 6 21H18C19.654 21 21 19.654 21 18V12C21 11.448 20.553 11 20 11Z",
      fill: !ignoreColor ? color : undefined
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.5164 7.83273L16.1582 5.47132L17.8627 3.76356L20.22 6.1241L18.5164 7.83273ZM12.445 13.919L9.84014 14.1564L10.0711 11.5663L14.986 6.64457L17.345 9.00686L12.445 13.919ZM21.4784 4.90529L21.4775 4.90441L19.0818 2.50532C18.4334 1.85779 17.3195 1.82712 16.7053 2.44486L8.83378 10.3273C8.54853 10.6121 8.37178 10.9906 8.33503 11.3911L8.00341 15.0449C7.98066 15.3034 8.07253 15.5593 8.25628 15.7433C8.42166 15.9089 8.64478 16 8.87491 16C8.90203 16 8.92828 15.9991 8.95453 15.9965L12.6033 15.6644C13.004 15.6276 13.3812 15.4515 13.6655 15.1667L21.5379 7.28335C22.1749 6.64371 22.1478 5.57647 21.4784 4.90529Z",
      fill: !ignoreColor ? color : undefined
    })]
  });
};
export default ClassNote;